export default function getTime(messageTime = Date.now()) {
  const now = new Date();
  const timeString = new Date(messageTime);

  if (
    timeString.getDate() === now.getDate() &&
    timeString.getMonth() === now.getMonth() &&
    timeString.getFullYear() === now.getFullYear()
  ) {
    return timeString.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
    });
  } else {
    return timeString.toLocaleString("en-US", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
  }
}
